import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { MplButton } from '@mopla/ui';
import { VerificationIcon } from '@mopla/ui/icons';

import { useRedirectToTrueLayer } from '../../utils';

interface IProps {
	handleOnClose?: VoidFunction;
}

export const PaymentInfoStep: FC<IProps> = ({ handleOnClose }) => {
	const { t } = useTranslation('payment');

	const onRedirectToTrueLayerHandler = useRedirectToTrueLayer();

	return (
		<Box sx={{ display: 'grid', gridGap: '16px' }}>
			<Box sx={{ margin: '0 auto' }}>
				<VerificationIcon />
			</Box>
			<Typography variant="h2">{t('account_verification.title')}</Typography>
			<Typography variant="body1">{t('account_verification.text')}</Typography>
			<MplButton
				testId="PaymentInfoStep-verifyButton"
				onClick={onRedirectToTrueLayerHandler}
			>
				{t('account_verification.button')}
			</MplButton>
			<MplButton
				testId="PaymentInfoStep-cancelButton"
				variant="outlined"
				onClick={handleOnClose}
			>
				{t('edit_modal.button.cancel')}
			</MplButton>
		</Box>
	);
};
